var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container visitReportAudit" },
    [
      _c("div", { staticClass: "searchBox" }, [
        _c(
          "div",
          { staticClass: "searchBox_top" },
          [
            _vm.showButton
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.pass()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.ApprovalPass")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.refuseVisible = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("visitPlan.ApprovalReject")))]
                  ),
                ]
              : _vm._e(),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.goBack } },
              [_vm._v(_vm._s(_vm.$t("common.close")))]
            ),
          ],
          2
        ),
      ]),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "报告明细", name: "first" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("MSV Basic Info")])]
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.queryCondition,
                        inline: "",
                        "label-width": "240px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "MSV 单据编号", prop: "msvNo" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.queryCondition.msvNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "msvNo", $$v)
                              },
                              expression: "queryCondition.msvNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Year"),
                            prop: "year",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.queryCondition.year,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "year", $$v)
                              },
                              expression: "queryCondition.year",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Type"),
                            prop: "type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "type", $$v)
                                },
                                expression: "queryCondition.type",
                              },
                            },
                            _vm._l(_vm.typeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category", prop: "category" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "category", $$v)
                                },
                                expression: "queryCondition.category",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.SupplierFacility"),
                            prop: "plantName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.queryCondition.plantName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "plantName", $$v)
                              },
                              expression: "queryCondition.plantName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Report by", prop: "createBy" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.createBy,
                              callback: function ($$v) {
                                _vm.createBy = $$v
                              },
                              expression: "createBy",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.CreateDate"),
                            prop: "dataArr",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: "选择日期",
                              disabled: "",
                            },
                            model: {
                              value: _vm.queryCondition.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "createDate", $$v)
                              },
                              expression: "queryCondition.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Visit Type", prop: "visitType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.visitType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "visitType", $$v)
                                },
                                expression: "queryCondition.visitType",
                              },
                            },
                            _vm._l(_vm.visitTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Report to（Supplier)",
                            prop: "supplierEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", type: "textarea", rows: 3 },
                            model: {
                              value: _vm.queryCondition.supplierEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEmail",
                                  $$v
                                )
                              },
                              expression: "queryCondition.supplierEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Report (McD)", prop: "mcdEmail" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", type: "textarea", rows: 3 },
                            model: {
                              value: _vm.queryCondition.mcdEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "mcdEmail", $$v)
                              },
                              expression: "queryCondition.mcdEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Attendees Supplier",
                            prop: "attendeesSupplier",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", type: "textarea", rows: 3 },
                            model: {
                              value: _vm.queryCondition.attendeesSupplier,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "attendeesSupplier",
                                  $$v
                                )
                              },
                              expression: "queryCondition.attendeesSupplier",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            width: "200",
                            label: "Attendees McDonald’s(& On behalf)",
                            prop: "attendeesMcd",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", type: "textarea", rows: 3 },
                            model: {
                              value: _vm.queryCondition.attendeesMcd,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "attendeesMcd",
                                  $$v
                                )
                              },
                              expression: "queryCondition.attendeesMcd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mgt. recap", prop: "mgtRecap" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.mgtRecap,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mgtRecap", $$v)
                                },
                                expression: "queryCondition.mgtRecap",
                              },
                            },
                            _vm._l(_vm.mgtRecapList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "MSV Result", prop: "msvResult" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.msvResult,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "msvResult", $$v)
                                },
                                expression: "queryCondition.msvResult",
                              },
                            },
                            _vm._l(_vm.msvResultList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-form-item", {
                            attrs: { label: "On-site observations Number" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "highScoreClass",
                              attrs: { label: "High Risk", prop: "highScore" },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.queryCondition.highScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "highScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.highScore",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ScoreClass",
                              attrs: {
                                label: "Medium Risk",
                                prop: "mediumScore",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.queryCondition.mediumScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "mediumScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.mediumScore",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "ScoreClass",
                              attrs: { label: "Low Risk", prop: "lowScore" },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.queryCondition.lowScore,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "lowScore",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.lowScore",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "CAP Implementation  Status",
                            prop: "capImplementationStatus",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.queryCondition.capImplementationStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "capImplementationStatus",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryCondition.capImplementationStatus",
                              },
                            },
                            _vm._l(
                              _vm.capImplementationStatusList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.chineseValue,
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.VisitDate"),
                            prop: "dataArr",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": _vm.$t("common.to"),
                              "start-placeholder": _vm.$t("common.startDate"),
                              "end-placeholder": _vm.$t("common.endDate"),
                              disabled: "",
                            },
                            model: {
                              value: _vm.dataArr,
                              callback: function ($$v) {
                                _vm.dataArr = $$v
                              },
                              expression: "dataArr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "tableList",
                      staticClass: "purposeList",
                      attrs: { data: _vm.tableList, border: "", fit: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "50" },
                      }),
                      _c("el-table-column", {
                        attrs: { type: "index", label: "序号", width: "50" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "visitPurpose",
                          label: _vm.$t("visitPlan.visitPurpose"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-autocomplete", {
                                  staticClass: "inline-input",
                                  attrs: {
                                    "fetch-suggestions": _vm.querySearch,
                                    disabled: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: scope.row.visitPurpose,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "visitPurpose", $$v)
                                    },
                                    expression: "scope.row.visitPurpose",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("附件")])]
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.fileList,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          sortable: "",
                          prop: "documentName",
                          label: _vm.$t("common.file"),
                          "min-width": "130px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadFileFDP(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.documentName))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "second" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.approvalList, border: "", fit: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("common.remarks"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "审批拒绝", visible: _vm.refuseVisible },
          on: {
            "update:visible": function ($event) {
              _vm.refuseVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "refuseForm",
              attrs: {
                model: _vm.refuseForm,
                rules: _vm.refuseFormRules,
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "请填写拒绝原因 ",
                    "label-width": "120",
                    prop: "comments",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "300" },
                    model: {
                      value: _vm.refuseForm.comments,
                      callback: function ($$v) {
                        _vm.$set(_vm.refuseForm, "comments", $$v)
                      },
                      expression: "refuseForm.comments",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.refuseVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refuse("refuseForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }